export default __webpack_public_path__ + "static/po-system1-153d3ab92c6886c4b67f4206da4233a0.png";